import styled from 'styled-components';
import { colors } from '@keen.io/colors';
export var Section = styled.div.withConfig({
  displayName: "Appstyles__Section",
  componentId: "keen-widget-settings__hvofug-0"
})(["&&&{padding:10px 20px;width:100%;}"]);
export var Layout = styled.div.withConfig({
  displayName: "Appstyles__Layout",
  componentId: "keen-widget-settings__hvofug-1"
})(["&&&{position:relative;display:flex;background:", ";min-height:360px;}"], colors.white[500]);
export var SideMenuWrapper = styled.div.withConfig({
  displayName: "Appstyles__SideMenuWrapper",
  componentId: "keen-widget-settings__hvofug-2"
})(["&&&{width:160px;padding:10px;border-right:1px solid ", ";}"], colors.gray[200]);
export var HeadingSettingsContainer = styled.div.withConfig({
  displayName: "Appstyles__HeadingSettingsContainer",
  componentId: "keen-widget-settings__hvofug-3"
})(["&&&{display:flex;flex-direction:column;max-width:550px;}"]);